import styled from "styled-components";
import { Dropdown as BootstrapDropdown } from "react-bootstrap";

export const Container = styled.div`
  width: 100%;
  background-color: #ffffff;
  padding: 0 40px;
  @media (max-width: 770px) {
    padding: 0 0;
    ${(props) => props.disabledOnMobile && "display: none"}
  }
`;

export const ResaleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
`;

export const ResaleContent = styled.div`
  width: auto;
  padding: 10px 15px;
  box-shadow: 0px 3px 6px #00000029;
  border-bottom-left-radius: ${(props) => props.expand ? `0px` : `20px`};
  border-bottom-right-radius: ${(props) => props.expand ? `0px` : `20px`};
  background-color: #00FFFF;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  @media (min-width: 768px) {
    padding: 15px 15px;
  }

  @media (max-width: 1325px) {
    width: 100%;
    margin-bottom: 35px;
  }
`;

export const ReleaseIcon = styled.img`
  width: 35px;
  height: auto;
  cursor: ${(props) => (props.pointer ? "pointer" : "default")};
  @media (max-width: 1200px) {
    width: 30px;
  }
  @media (max-width: 1000px) {
    width: 25px;
  }
  @media (max-width: 770px) {
    width: 40px;
  }
  @media (max-width: 500px) {
    width: 30px;
  }
`;

export const ReleaseInfo = styled.span`
  color: ${(props) => props.color};
  font-size: 14px;
  margin-left: 15px;
  margin-right: 5px;
  @media (max-width: 1200px) {
    font-size: 12px;
  }
  @media (max-width: 1000px) {
    font-size: 11px;
  }
  @media (max-width: 770px) {
    font-size: 12px;
    margin-left: 10px;
    margin-right: 0px;
  }
`;

export const UserInfoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: -60px;
  margin-bottom: 20px;

  @media(min-width: 770px) and (max-width: 1320px) {
    margin-bottom: 0px;
  }
`;

export const AvatarIcon = styled.i`
  color: #ffffff;
  font-size: 200%;

  @media(min-width: 770px) {
    color: #000FFF;
    font-size: 240%;
    margin: 0 .6rem 0 1rem;
  }
`;

export const UserTexts = styled.div`
  color: ${(props) => props.color};
  max-width:85%;

  h6 {
    font-size: 18px;
    margin: 0;
    font-weight: bold;
    margin-top: 3px;
    margin-bottom: -3px;
  }
  button {
    background:none;
    border: none;
    padding: 0;
    font-size: 14px;
    margin: 0;
    font-weight: 300;
    svg{
      color:#00F;
    }
  }

  @media(min-width: 771px) and (max-width: 850px) {
    max-width:75%;
  }
`;

export const DesktopWrapper = styled.div`
  width: 100%;
  @media (max-width: 770px) {
    display: none;
  }
`;

export const MobileWrapper = styled.div`
  display: none;
  width: 100%;
  padding: ${(props) => props.lapidar ? "0px" : "20px"};
  background-color: ${(props) => props.lapidar ? "transparent" : "#00FFFF"};
  @media (max-width: 770px) {
    display: flex;
    flex-direction: column;
  }
`;

export const LogoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  img {
    width: 150px;
    height: auto;
    margin-bottom: 15px;
  }
`;

export const MobileUserInfoContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  i {
    color: #000FFF;
    font-size: 38px;
  }
`;

export const ResaleMobileContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ResaleMobileContent = styled.div`
  width: 80%;
  margin-top: 20px;
  padding: 20px;
  box-shadow: 0px 3px 6px #00000066;
  border-radius: ${(props) => props.expand ? `20px 20px 0 0` : `20px`};
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 770px) {
    padding: 20px 10px;
    width: 100%;
  }
`;

export const DropdownWrapper = styled.div`
  .btn-primary:not(:disabled):not(.disabled).active,
  .btn-primary:not(:disabled):not(.disabled):active,
  .show > .btn-primary.dropdown-toggle {
    background-color: orange !important;
  }
`;


export const DropdownButton = styled(BootstrapDropdown.Toggle)`
  background-color: transparent;
  border-color: transparent;
`;

export const DropdownMenu = styled(BootstrapDropdown.Menu)`
  width: 100%;
  height: 150px;
  background-color: #ffffff;
`;

export const ColorIconMobile = {
  color: "#808080",
  cursor: "pointer",
};

export const ColorIconDesktop = {
  color: "#000FFF",
  cursor: "pointer",
};

export const CreatedIconStyles = {
  width: ".9em",
  marginLeft: ".3rem",
  cursor: "pointer",
};

export const CreatedIconStylesMobile = {
  width: ".9em",
  marginLeft: ".3rem",
  color: "#000FFF",
};

export const DropdownMenuLogout = {
  minWidth: 250,
  padding: "20px !important",
  maxHeight: 300,
  overflow: "auto",
  borderRadius: 10,
  borderWidth: 0,
  boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.2)",
  border: "1px solid #D4D4D4",
  color: "#808080",
};

export const ConfigModal = styled(BootstrapDropdown.Toggle)`
  background-color: transparent;
  border: 0;

  i {
    font-size: 20px;
    color: #000FFF;
    cursor: pointer;
    margin-left: 10px;
    margin-top: -20px;
  }

  &:hover {
    background-color: transparent;
  }

  @media (max-width: 768px) {
    i {
      font-size: 20px;
      color: #ffffff;
      cursor: pointer;
      margin-left: 10px;
      margin-top: -20px;
    }
  }
`;

export const AreaTop = styled.div`
  display: flex;
  flex-direction: row;
  align-items: right;
`;

export const TextNotification = styled.div`
  inline-size: 300px;
  color: rgb(62, 80, 96);
  font-weight: 400;
  font-size: 0.875rem;
  word-wrap: break-word;  
  overflow-wrap: break-word;    
`;

export const AreaItemNotificationTitle = styled.div`
  margin: 20px;
  color: #808080;
`;

export const AreaItemNotificationScroll = styled.div`
  height: 300px;
  overflow-y: scroll;
`;

export const AreaItemNotificationData = styled.div`
  margin-top: 12px;
  margin-bottom: 12px;
  &:hover {
    background: #e2e2e2;
  }
`;

export const AreaItemNotification = styled.div`
  margin-left: 20px;
  margin-right: 20px;
  color: ${(props) => props.read ? '#000000' : '#808080'};
  display: flex;
  justify-content: left;
  padding-bottom: 2px;
  font-size: 14px;
  cursor: pointer;
`;

export const AreaItemNotificationDate = styled.div`
  margin-left: 20px;
  margin-right: 20px;
  color: #aeaeae;
  display: flex;
  justify-content: end;
  padding-bottom: 4px;
  font-size: 10px;
  cursor: pointer;

  &:hover {
    background: #e2e2e2;
  }
`;

export const AreaNotificationExit = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

